import { z as zod } from 'zod';
import { Enum_Componentlinkslink_Type } from "@/app/lib/generated/graphql-types";

const ExternalLinkSchema = zod.object({
    id: zod.string(),
    url: zod.string()
        .min(1, { message: 'URL fehlt' })
        .pipe(
            zod.string().url({ message: "Ungültige externe URL" }),
        ),
    name: zod.string().nullish(),
    type: zod.literal(Enum_Componentlinkslink_Type.External),
});

const InternalLinkSchema = zod.object({
    id: zod.string(),
    url: zod
        .string()
        .min(1, { message: 'URL fehlt' })
        .pipe(
            zod.string().regex(/^\/(?!\/)/, { message: 'Interner Pfad muss mit "/" beginnen' }),
        ),
    name: zod.string().nullish(),
    type: zod.literal(Enum_Componentlinkslink_Type.Internal),
});

export const LinkSchema = zod.discriminatedUnion('type', [
    ExternalLinkSchema,
    InternalLinkSchema,
]);

export type LinkEditable = zod.infer<typeof LinkSchema>;
